import React from 'react';
import Grid from '@material-ui/core/Grid';
import { TextFieldCustom } from './ui/TextFieldCustom';
import SelectFieldCustom from './ui/SelectFieldCustom';
import { useTranslation } from 'react-i18next';
import { PlacesAutocomplete } from './ui/PlacesAutocomplete';
import { useFieldArray, useFormContext } from 'react-hook-form';

export default function FormPersonalDetails(props) {
    const { t } = useTranslation();
    const { control } = useFormContext();
    const { fields } = useFieldArray({
        control,
        name: 'applicants',
        shouldUnregister: false
    });

    const provincesItems = t('los:province', { returnObjects: true });
    const occupanttype = t('los:occupanttype', { returnObjects: true });

    return (
        <>
            <div className="mb-8">
                <div className="bg-white h-12 border border-l-4 rounded px-5">
                    <div className="text-lg font-semibold mb-4 mt-2 text-gray-700">
                        {t('personLabels.title')}
                    </div>
                </div>
            </div>
            <div>
                {fields.map((applicant, i) => {
                    return (
                        <div key={applicant.id}>
                            {i === 1 ? (
                                <>
                                    <div className="my-8">
                                        <div className="bg-white h-12 border border-l-4 rounded px-5">
                                            <div className="text-lg font-semibold mb-4 mt-2 text-gray-700">
                                                {t('personLabels.title2')}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : null}
                            <Grid container spacing={3}>
                                <Grid item md={6} xs={12}>
                                    <TextFieldCustom
                                        name={`applicants[${i}].firstName`}
                                        label={t('personLabels.firstName')}
                                        defaultValue={applicant.firstName}
                                        inputProps={{ maxLength: 25 }}
                                    />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <TextFieldCustom
                                        name={`applicants[${i}].lastName`}
                                        label={t('personLabels.lastName')}
                                        defaultValue={applicant.lastName}
                                        inputProps={{ maxLength: 25 }}
                                    />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <TextFieldCustom
                                        name={`applicants[${i}].dateOfBirth`}
                                        label={t('personLabels.dob')}
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        defaultValue={applicant.dateOfBirth}
                                    />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <TextFieldCustom
                                        name={`applicants[${i}].email`}
                                        label={t('personLabels.email')}
                                        defaultValue={applicant.email}
                                    />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <PlacesAutocomplete
                                        name={`applicants[${i}].address.location`}
                                        label={t('personLabels.address')}
                                        index={i}
                                        defaultValue={applicant.address.location}
                                    />
                                </Grid>
                                <Grid item md={3} xs={6}>
                                    <TextFieldCustom
                                        name={`applicants[${i}].address.unit`}
                                        label={t('personLabels.unit')}
                                        helperText={t('optionalField')}
                                        defaultValue={applicant.address.unit}
                                        inputProps={{ maxLength: 6 }}
                                    />
                                </Grid>
                                <Grid item md={3} xs={6}>
                                    <TextFieldCustom
                                        name={`applicants[${i}].address.poBox`}
                                        label={t('personLabels.poBox')}
                                        helperText={t('optionalField')}
                                        defaultValue={applicant.address.poBox}
                                    />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <TextFieldCustom
                                        name={`applicants[${i}].address.city`}
                                        label={t('personLabels.city')}
                                        defaultValue={applicant.address.city}
                                    />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <SelectFieldCustom
                                        name={`applicants[${i}].address.province`}
                                        label={t('personLabels.province')}
                                        items={provincesItems}
                                        defaultValue={applicant.address.province}
                                    />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <TextFieldCustom
                                        name={`applicants[${i}].address.postalCode`}
                                        label={t('personLabels.postalCode')}
                                        defaultValue={applicant.address.postalCode}
                                        postalcode="true"
                                    />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <SelectFieldCustom
                                        name={`applicants[${i}].address.occupationtype`}
                                        label={t('personLabels.occType')}
                                        items={occupanttype}
                                        defaultValue={applicant.address.occupationtype}
                                    />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <TextFieldCustom
                                        name={`applicants[${i}].address.since`}
                                        label={t('personLabels.addressSince')}
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        defaultValue={applicant.address.since}
                                    />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <TextFieldCustom
                                        name={`applicants[${i}].phone`}
                                        label={t('personLabels.phone')}
                                        phone="true"
                                        defaultValue={applicant.phone}
                                    />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <TextFieldCustom
                                        name={`applicants[${i}].sin`}
                                        label={t('personLabels.sin')}
                                        helperText={t('optionalField')}
                                        defaultValue={applicant.sin}
                                        sin="true"
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    );
                })}
            </div>
        </>
    );
}
